import { ILesson } from '@/@types'
import { Svg } from '@/components'
import { ColumnHeader } from '@/components/data-table/column-header'
import { ColumnDef } from '@tanstack/react-table'

export const TABLE_COLUMNS: ColumnDef<ILesson>[] = [
  {
    id: 'title',
    accessorKey: 'title',
    header: ({ column }) => <ColumnHeader column={column} title="Nome" />,
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        <Svg src="/icons/play_video.svg" className="max-w-6" />
        <span>{row.original.title}</span>
      </div>
    ),
  },
  {
    id: 'module.name',
    accessorKey: 'module.name',
    header: 'Modulo',
    cell: ({ row }) => row.original.module.name,
    filterFn: (row, id, value) => String(value).includes(row.getValue(id)),
  },
  {
    id: 'video.duration',
    accessorKey: 'video.duration',
    header: ({ column }) => <ColumnHeader column={column} title="Duração" />,
    cell: ({ row }) => row.original.video.duration ?? '-',
    filterFn: (row, id, value) => String(value).includes(row.getValue(id)),
  },
  {
    id: 'level',
    accessorKey: 'level',
    header: 'Nível',
    cell: ({ row }) => `Nível ${row.original.module.level}`,
    filterFn: (row, _, value) => {
      const lessonLevel = row.original.module.level

      if (!value || value.length === 0) {
        return true
      }

      const filterLevels = Array.isArray(value)
        ? value.map((v) => parseInt(v.replace('level ', '')))
        : [parseInt(value.replace('level ', ''))]

      return filterLevels.includes(lessonLevel)
    },
  },
  {
    id: 'position',
    accessorKey: 'position',
    header: ({ column }) => <ColumnHeader column={column} title="Posição" />,
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: ({ column }) => <ColumnHeader column={column} title="Descrição" />,
  },
]
